import { systemCode } from "..";
import { decreaseOddsBy3Percent } from "./decreaseBy3Percent";
import { parseBetsData } from "./parseBetsData";
import { unmappedMarkets } from "./unmapped-markets";
import { setCustomizedOdds } from "./utils";

/**
 * @param matchData: 
 * @param aggregate: the IDs of the aggregates associated with the match
 * @param macrogruppo: the ID of the macro to which the bets belong to
 * @param bets: the bets to parse
 * @param isLive: true if match is ive
 *  */
export function parseBetsDataMacrogruppo(matchData, aggregate, macrogruppo, bets, isLive) {
    setCustomizedOdds(bets);
    if (isLive && systemCode === 'NETBET') {
        decreaseOddsBy3Percent(matchData, bets);
    }

    matchData.isLive = isLive;

    const aggregateQuotateMap = new Set(aggregate);

    let agList = macrogruppo.aggregate.filter(ag => aggregateQuotateMap.has(ag.idAggregata));
    if (macrogruppo.id < 0) {
        // I make a fake bet group for unmapped bets and add it to the actual bet groups
        const unmappedMarketsMap = unmappedMarkets.getAll();
        if (unmappedMarketsMap.size > 0) {
            const unmappedBets = [];
            const unmappedBetsById = new Set();
            bets.forEach(bet => {
                const id = `${matchData.sportRef}_${isLive ? 'lv' : 'pr'}_${bet.cs}_${0}`;
                if (unmappedMarketsMap.has(id)) {
                    if (!unmappedBetsById.has(id)) {
                        unmappedBetsById.add(id);
                        const bet = unmappedMarkets.getCopyOf(id);
                        bet.isUnmapped = true;
                        unmappedBets.push(bet);
                    }
                }
            });
            const unmappedAg = {
                compattate: null,
                descrizione: "UNMAPPED",
                idAggregata: -1,
                isPrincipale: false,
                ranking: 0,
                scommesse: unmappedBets
            };
            agList = agList.concat(unmappedAg);
        }
    }

    const betsSet = new Set();
    let parsedBets = [];
    const aggById = new Map();
    agList.forEach(agg => {
        aggById.set(agg.idAggregata, agg);
        const result = parseBetsData(matchData, [agg.idAggregata], agg.idAggregata, bets, isLive, true, true);
        result.bets.forEach(bet => {
            if (!betsSet.has(bet.uniqueId)) {
                betsSet.add(bet.uniqueId);
                parsedBets.push(bet);
            }
        });
    });

    return parsedBets;
}
